import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllMails } from "../../../redux/actions/authActions";
import SearchBar from "../../../components/searchbar/SearchBar";

const MailHome = () => {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const mails = useSelector((state) => state.auth.allMails);

  useEffect(() => {
    if (token) {
      dispatch(getAllMails());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (!Array.isArray(mails)) return;

    const mappedRows = mails.map((mail, index) => {
      const to = mail.to || {};

      return {
        id: index + 1, // DataGrid internal ID
        mailId: mail._id, // MongoDB ID (used for navigation)
        sentOn: mail.createdAt?.split("T")[0] || "N/A",
        clientName: to.name || mail.name || "N/A",
        email: mail.emailAddress || to.email || "N/A",
        clientType: to.clientType || mail.clientType || "N/A",
        serviceTaken: Array.isArray(to.services)
          ? to.services.map((s) => s.name).join(", ")
          : "N/A",
        mailStatus: mail.status || "Sent",
      };
    });

    setRows(mappedRows);
  }, [mails]);

  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      setRows(
        mails.map((mail, index) => ({
          id: index + 1,
          mailId: mail._id,
          sentOn: mail.createdAt?.split("T")[0] || "N/A",
          clientName: mail.to?.name || mail.name || "N/A",
          email: mail.emailAddress || mail.to?.email || "N/A",
          clientType: mail.to?.clientType || mail.clientType || "N/A",
          serviceTaken: Array.isArray(mail.to?.services)
            ? mail.to.services.map((s) => s.name).join(", ")
            : "N/A",
          mailStatus: mail.status || "Sent",
        }))
      );
      return;
    }

    const filtered = mails.filter((mail) =>
      (mail.to?.name || mail.name || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );

    setRows(
      filtered.map((mail, index) => ({
        id: index + 1,
        mailId: mail._id,
        sentOn: mail.createdAt?.split("T")[0] || "N/A",
        clientName: mail.to?.name || mail.name || "N/A",
        email: mail.emailAddress || mail.to?.email || "N/A",
        clientType: mail.to?.clientType || mail.clientType || "N/A",
        serviceTaken: Array.isArray(mail.to?.services)
          ? mail.to.services.map((s) => s.name).join(", ")
          : "N/A",
        mailStatus: mail.status || "Sent",
      }))
    );
  };

  const columns = [
    { field: "mailId", headerName: "Mail ID", width: 180 },
    { field: "sentOn", headerName: "Sent On", width: 140 },
    { field: "clientName", headerName: "Client Name", width: 200 },
    { field: "email", headerName: "Email Address", width: 240 },
    { field: "clientType", headerName: "Client Type", width: 160 },
    { field: "serviceTaken", headerName: "Service Taken", width: 220 },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/mails/mail-details/${params.row.mailId}`);
          }}
          className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm hover:bg-blue-700"
        >
          View
        </button>
      ),
    },
  ];

  return (
    <>
      <SearchBar
        titleOne="Mails"
        onSearch={handleSearch}
        showEditButton={false}
        showAddButton={false}
      />

      <div className="bg-white rounded-xl shadow-lg border p-6">
        <h2 className="text-xl font-semibold mb-4">Mails</h2>

        <div className="h-[500px]">
          <DataGrid
            rows={rows}
            columns={columns}
            pageSizeOptions={[5, 8, 10, 25]}
            initialState={{ pagination: { paginationModel: { pageSize: 8, page: 0 } } }}
            disableRowSelectionOnClick
          />
        </div>
      </div>
    </>
  );
};

export default MailHome;
